export function TaskPreview({ v, criteria }) {
  return (
    <div className="space-y-5" data-testid="task-preview">
      <div><h2 className="text-2xl font-semibold tracking-tight">{v.title}</h2><p className="mt-2 leading-relaxed text-ink-secondary">{v.scenario}</p></div>
      <div><h3 className="mb-1 text-sm font-semibold">What to do</h3><p className="whitespace-pre-line text-sm leading-relaxed text-ink">{v.instructions}</p></div>
      {v.materials?.map((m) => (
        <div key={m.title} className="space-y-1"><h3 className="text-sm font-semibold">{m.title}</h3>
          {m.kind === "table" ? (
            <div className="overflow-x-auto rounded-lg border border-line"><table className="w-full text-xs">
              <thead className="bg-subtle"><tr>{m.columns.map((c) => <th key={c} className="px-3 py-2 text-left font-medium">{c}</th>)}</tr></thead>
              <tbody className="divide-y divide-line">{m.rows.map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j} className="px-3 py-1.5">{c}</td>)}</tr>)}</tbody>
            </table></div>
          ) : <p className="whitespace-pre-line rounded-lg bg-subtle p-3 text-sm">{m.content}</p>}
        </div>
      ))}
      <div><h3 className="mb-1 text-sm font-semibold">Hand in</h3><ul className="list-disc pl-5 text-sm">{v.deliverables.map((d) => <li key={d}>{d}</li>)}</ul></div>
      {criteria?.length > 0 && <p className="text-xs text-ink-muted">You'll be assessed on: {criteria.join(" · ")}</p>}
    </div>
  );
}
